module.exports = __webpack_public_path__ + "static/img/p2.2a94472.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/szr/p2.png
// module id = vUlY
// module chunks = 0